// @flow

import styled, { css } from 'styled-components';
import circleSvgSrc from './circle.svg';
import dashedSvgSrc from './dashed.svg';

export const Separator = styled.div`
  ${({ direction, size = 1 }) => (direction === 'vertical' || direction === 'v') && css`
    width: 100%;
    height: ${Math.pow(2, size)}px;
  `}

  ${({ direction, size = 1 }) => (direction === 'horizontal' || direction === 'h') && css`
    display: inline-block;
    height: 100%;
    width: ${Math.pow(2, size)}px;
  `}

  background-position-y: center;

  ${({ pattern }) => pattern === 'dotted' && css`
    background-repeat: repeat-x;
    background-image: url(${circleSvgSrc});
  `}

  ${({ pattern }) => pattern === 'dashed' && css`
    background-repeat: repeat-x;
    background-image: url(${dashedSvgSrc});
  `}
`;
